import React from 'react'
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
  MDBInput,
  MDBRow,
  MDBCol,
} from 'mdb-react-ui-kit'

import EnrollmentLinkCreator from './EnrollmentLinkCreator.component'

const EnrollmentLinkManager = ({ showModal, toggleModal }) => {
  return (
    <MDBModal open={showModal} tabIndex='-1' onClose={toggleModal} className='AgentNavEnrollment'>
      <MDBModalDialog size='lg'>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>Agent Enrollment Link</MDBModalTitle>
            <MDBBtn type='button' className='btn-close' color='none' onClick={toggleModal}></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>
            <MDBRow>
              <MDBCol size='12'>
                <EnrollmentLinkCreator />
              </MDBCol>
            </MDBRow>
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn type='button' color='default' className='btn-block' onClick={toggleModal}>
              Close
            </MDBBtn>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  )
}

export default EnrollmentLinkManager
